// extracted by mini-css-extract-plugin
export var cardIcon = "_97-4";
export var checkboxCard = "_97-0";
export var checkboxCardSelected = "_97-3";
export var disabled = "_97-1";
export var outerBorder = "_97-2";
export var spacerMedium = "_97-7";
export var spacerSmall = "_97-6";
export var spacerXsmall = "_97-5";